import { orgService } from "@/services";
import { useQuery } from "@tanstack/react-query";
import { qk } from "./queryKeys";

/** The shell's bootstrap. Everything renders off this. */
export function useOrg() {
	return useQuery({
		queryKey: qk.org,
		queryFn: ({ signal }) => orgService.getMe(signal),
		staleTime: 30_000,
	});
}
